import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { EqualHeightTouchableOpacity } from './equal-height-touchable-opacity';
import { StyleProp, View, ViewStyle } from 'react-native';

export const CATALOG_ITEM_CARD_MARGIN = 4;
export const CATALOG_ITEM_CARD_PADDING = 8;

interface Props {
  cardStyle?: StyleProp<ViewStyle>;
  children: React.ReactNode;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
}

export const CatalogItemCard: React.FC<Props> = ({
  cardStyle,
  children,
  onPress,
  style,
}) => {
  const [styles] = useStyles();

  return (
    <EqualHeightTouchableOpacity
      disabled={!onPress}
      focusable={false}
      onPress={onPress}
      style={[styles.base, style]}
    >
      <View style={[styles.card, cardStyle]}>{children}</View>
    </EqualHeightTouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    margin: CATALOG_ITEM_CARD_MARGIN,
  },
  card: {
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.background,
    borderRadius: 4,
    borderWidth: 1,
    flex: 1,
    justifyContent: 'space-between',
    padding: CATALOG_ITEM_CARD_PADDING,
  },
}));
